import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createContext, useContext } from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
var initialState = {
  fullScreen: false,
  externalEmbed: false,
  elements: {
    closeButton: true,
    newChatButton: true,
    fullscreenButton: true,
    createAgentButton: true,
    browseAgentsButton: true
  }
};
export var uiConfigDefaults = initialState;
var uiConfig = /*#__PURE__*/createContext(initialState);
export var UIConfigProvider = uiConfig.Provider;
export var useUIConfig = function useUIConfig() {
  return useContext(uiConfig);
};
export var createUIConfig = function createUIConfig(config) {
  // Allow fullscreen override for branch deploy testing purposes
  var processedConfig = localStorage.getItem('DEBUG_rovo_chat_fullscreen') === 'true' && fg('rovo_chat_show_local_frontend_components') ? _objectSpread(_objectSpread({}, config), {}, {
    fullScreen: true
  }) : config;
  return _objectSpread(_objectSpread(_objectSpread({}, initialState), processedConfig), {}, {
    elements: _objectSpread(_objectSpread({}, initialState.elements), processedConfig === null || processedConfig === void 0 ? void 0 : processedConfig.elements)
  });
};